export default{heading:"w_D6",large:"w_D7",medium:"w_D8",small:"w_D9",weight400:"w_EA",weight700:"w_EB"};
